namespace TabAurous.HR {
    export interface AttendanceForm {
        TransDate: Serenity.DateEditor;
        VoucherNo: Serenity.StringEditor;
        Details: AttendanceDetailsEditor;
        CompanyId: Serenity.IntegerEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        UserId: Serenity.IntegerEditor;
    }

    export class AttendanceForm extends Serenity.PrefixedContext {
        static formKey = 'HR.Attendance';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!AttendanceForm.init)  {
                AttendanceForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.StringEditor;
                var w2 = AttendanceDetailsEditor;
                var w3 = s.IntegerEditor;

                Q.initFormType(AttendanceForm, [
                    'TransDate', w0,
                    'VoucherNo', w1,
                    'Details', w2,
                    'CompanyId', w3,
                    'VoucherTypeId', w3,
                    'UserId', w3
                ]);
            }
        }
    }
}
